console.log('ACTIVIS - App.js loadé');

import './_header';
import './_delegate-link';

/* retirer les id vide pour ne pas avoir d erreur d'accessibilité */
setTimeout(function () {
    const $refs = document.querySelectorAll("*[id='']");

    if ($refs) {
        
        $refs.forEach(function ($ref) {
            $ref.removeAttribute('id');
        });
    }
}, 2000);
